// extracted by mini-css-extract-plugin
export default {"header":"styles_header__Avavr","calendar-header-date":"styles_calendar-header-date__JjBYO"};